<div [formGroup]="form" class="card mt-3">
  <div class="card-header">
    <a id="TargetLebensunterhalt"></a>
    <h3>
      <i class="icon-kostenuebernahme"></i> <span i18n>Lebensunterhalt und Aufenthaltsdetails</span>
      <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
      </span>
    </h3>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <app-lebensunterhalt formControlName="lebensunterhalt"></app-lebensunterhalt>
        <app-abweichender-verpflichtungsgeber formControlName="abweichenderVerpflichtungsgeber"
                                              *ngIf="isAbweichenderVerpflichtungsgeberVisible"></app-abweichender-verpflichtungsgeber>
        <app-fruehere-aufenthalte formControlName="fruehereAufenthalte"></app-fruehere-aufenthalte>
        <app-erklaerung formControlName="erklaerung"></app-erklaerung>
      </div>
    </div>
  </div>
</div>
